import Grid from "@material-ui/core/Grid";
import React, { useState } from "react";
import SbuSelect from './../../_shared/SbuSelect/SbuSelect';
import PropTypes from "prop-types";
import PlantSelect from "../../_shared/PlantSelect";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { Autocomplete } from "@material-ui/lab";
import DateFnsUtils from "@date-io/date-fns";
import { Accordion, AccordionDetails, AccordionSummary, Button, Checkbox, TextField, Typography } from "@material-ui/core";
import FactorySelect from "../../_shared/FactorySelect";
import UserSelect from "../../_shared/UserSelect";
import StudySelect from "../../_shared/StudySelect";
import ShiftSelect from "../../_shared/ShiftSelect";
import { APP_STUDIES, APP_STUDIES_LIST } from "../../../_constants";
import { utilFunctions } from "../../../_helpers";
import { UserDto, ShiftDto, SbuDto, StudyBrowserFiltersDto, PlantDto, FactoryDto, StudyBrowserListFiltersParamsDto, OperationMasterDto, OperatorMasterDto } from "../../../_models";
import { authorizationService } from "../../../_services";
import { ExpandMore } from "@material-ui/icons";
import FormControlWrapper from "../../_shared/FormControlWrapper";

const StudyBrowserFilters: React.FC<{
    sbus: SbuDto[],
    shifts: ShiftDto[];
    filteredPlants: PlantDto[];
    filteredFactories: FactoryDto[]
    filteredUsers: UserDto[],
    filteredOperationMasters: OperationMasterDto[],
    filteredOperatorMasters: OperatorMasterDto[],
    filterData: StudyBrowserFiltersDto;
    onFilterClear: () => void,
    onFilterApply: () => void,
    onFilterChange: (property: string, value: any) => void
    onFilterSearchTermChange: (property: string, value: any) => void
    }> = (props) => {
    const labelMinWidth = 100
    const [filtersAccordion, setFiltersAccordion] = useState(true)
    const [operationSearchTerm, setOperationSearchTerm] = React.useState('');
    const [operatorSearchTerm, setOperatorSearchTerm] = React.useState('');
    const [operationTimerId, setOperationTimerId] = React.useState(null);
    const [operatorTimerId, setOperatorTimerId] = React.useState(null);

    const onSearchTermChange = (event, searchTerm: string, type: string) => {
        if(type === "operationMasterId"){
            setOperationSearchTerm(searchTerm);
        } else {
            setOperatorSearchTerm(searchTerm);
        }
        if(event && event.type === "change") { //only load when user type
            loadOpMasters(searchTerm, type);
        }
    }
    
    const loadOpMasters = (searchTerm: string, type: string) => {
        //only 3 or more search terms 
        if(props.filterData.plantCode && props.filterData.factoryCode && searchTerm?.length < 3) return;
        let timerId = type === 'operationMasterId' ? operationTimerId : operatorTimerId;
        let setTimer = type === 'operationMasterId' ? setOperationTimerId : setOperatorTimerId;

        if(timerId){
            clearTimeout(timerId);
        }
        setTimer(setTimeout(() => {
            if(searchTerm){
                props.onFilterSearchTermChange(type, searchTerm)
            }
          }, 1000));
    }

    const onFilterClear = () => {
        setOperationSearchTerm("");
        setOperatorSearchTerm("");
        props.onFilterClear();
    }

    return (
        <Accordion
            className="appAccordion"
            expanded={filtersAccordion}
            onChange={(e, expanded) => setFiltersAccordion(expanded)}
        >
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography>Filters</Typography>
            </AccordionSummary>
            <AccordionDetails className="contentPadding">
                <Grid container spacing={3} className="appFilterContainer">
                    <Grid item xs={12} sm={12} md={6} lg={3} >
                        <FormControlWrapper label="SBU" variant="inline" labelMinWidth={labelMinWidth} isRequired={props.filterData.sbuId.isRequired}>
                            <SbuSelect
                                sbus={props.sbus}
                                error={!!props.filterData.sbuId.error}
                                selectedValue={props.filterData.sbuId.value}
                                onSbuChange={(value) => props.onFilterChange('sbuId', value)} />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3} >
                        <FormControlWrapper label="Plant" variant="inline" labelMinWidth={labelMinWidth} isRequired={props.filterData.plantId.isRequired}>
                            <PlantSelect
                                plants={props.filteredPlants}
                                error={!!props.filterData.plantId.error}
                                selectedValue={props.filterData.plantId.value}
                                onPlantChange={(value) => props.onFilterChange('plantId', value)} />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3} >
                        <FormControlWrapper label="Factory" variant="inline" labelMinWidth={labelMinWidth} isRequired={props.filterData.factoryId.isRequired}>
                            <FactorySelect
                                factories={props.filteredFactories}
                                error={!!props.filterData.factoryId.error}
                                selectedValue={props.filterData.factoryId.value}
                                onFactoryChange={(value) => props.onFilterChange('factoryId', value)} />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3} >
                        <FormControlWrapper label="User" variant="inline" labelMinWidth={labelMinWidth} isRequired={props.filterData.userId.isRequired}>
                            <UserSelect
                                users={props.filteredUsers}
                                onUserChange={(value) => props.onFilterChange('userId', value)}
                                selectedValue={props.filterData.userId.value} />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3} >
                        <FormControlWrapper label="Team Member" variant="inline" labelMinWidth={labelMinWidth} isRequired={props.filterData.operatorMasterId.isRequired}>
                            <Autocomplete
                                    getOptionLabel={(option) => option ? (option.epf + ' ' + option.name) : ""}
                                    size="small"
                                    fullWidth
                                    options={props.filteredOperatorMasters}
                                    autoComplete
                                    onInputChange={(event, newInputValue) => { onSearchTermChange(event, newInputValue, 'operatorMasterId');}}
                                    inputValue={operatorSearchTerm}
                                    onChange={(event,value:any) => props.onFilterChange('operatorMasterId', value?.id)}
                                    filterOptions={(x) => x}
                                    renderInput={(params) => <TextField {...params} variant="outlined" />}
                            />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3} >
                        <FormControlWrapper label="Operation" variant="inline" labelMinWidth={labelMinWidth} isRequired={props.filterData.operationMasterId.isRequired}>
                            <Autocomplete
                                    getOptionLabel={(option) => option ? option.name : ""}
                                    size="small"
                                    fullWidth
                                    options={props.filteredOperationMasters}
                                    autoComplete
                                    onInputChange={(event, newInputValue) => { onSearchTermChange(event, newInputValue, 'operationMasterId');}}
                                    inputValue={operationSearchTerm}
                                    onChange={(event,value:any) => props.onFilterChange('operationMasterId', value?.id)}
                                    filterOptions={(x) => x}
                                    renderInput={(params) => <TextField {...params} variant="outlined" />}
                            />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3} >
                        <FormControlWrapper label="Study" variant="inline" labelMinWidth={labelMinWidth} isRequired={props.filterData.studyId.isRequired}>
                            <StudySelect
                                studies={APP_STUDIES_LIST}
                                onStudyChange={(value) => props.onFilterChange('studyId', value)}
                                selectedValue={props.filterData.studyId.value} />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3} >
                        <FormControlWrapper label="Shift" variant="inline" labelMinWidth={labelMinWidth} isRequired={props.filterData.shiftCode.isRequired}>
                            <ShiftSelect
                                error={!!props.filterData.shiftCode.error}
                                shifts={props.shifts}
                                disabled={props.filterData.shiftCode.disabled}
                                onShiftChange={(value) => props.onFilterChange('shiftCode', value)}
                                selectedValue={props.filterData.shiftCode.value} />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3} >
                        <FormControlWrapper label="Module" variant="inline" labelMinWidth={labelMinWidth} isRequired={props.filterData.module.isRequired}>
                            <TextField
                                value={props.filterData.module.value}
                                size='small'
                                variant="outlined"
                                fullWidth
                                onChange={(event) => props.onFilterChange('module', event.target.value)} />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3} >
                        <FormControlWrapper label="Style" variant="inline" labelMinWidth={labelMinWidth} isRequired={props.filterData.style.isRequired}>
                            <TextField
                                value={props.filterData.style.value}
                                size='small'
                                variant="outlined"
                                fullWidth
                                onChange={(event) => props.onFilterChange('style', event.target.value)} />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3} >
                        <FormControlWrapper label="Version" variant="inline" labelMinWidth={labelMinWidth} isRequired={props.filterData.version.isRequired}>
                            <TextField
                                value={props.filterData.version.value}
                                size='small'
                                variant="outlined"
                                fullWidth
                                onChange={(event) => props.onFilterChange('version', event.target.value)} />
                        </FormControlWrapper>
                    </Grid>
                    {((`${props.filterData.studyId.value}` === `${APP_STUDIES.PROTENTIAL}` || `${props.filterData.studyId.value}` === `${APP_STUDIES.WORK_COMBINATION_AND_TIME_STUDY}`) && authorizationService.getAuthorizedUser().isAdmin) && (
                        <React.Fragment>
                            <Grid item xs={12} sm={12} md={6} lg={3} >
                                <FormControlWrapper label="GSD Code" variant="inline" labelMinWidth={labelMinWidth} isRequired={props.filterData.gsdCode.isRequired}>
                                    <TextField
                                        value={props.filterData.gsdCode.value}
                                        size='small'
                                        variant="outlined"
                                        fullWidth
                                        onChange={(event) => props.onFilterChange('gsdCode', event.target.value)} />
                                </FormControlWrapper>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={3} >
                                <FormControlWrapper label="Is Best Video" variant="inline" labelMinWidth={labelMinWidth} isRequired={props.filterData.gsdCode.isRequired}>
                                    <Checkbox
                                        checked={props.filterData.isBestVideo.value}
                                        size="small"
                                        color="primary"
                                        onChange={(event) => props.onFilterChange('isBestVideo', event.target.checked)}
                                    />
                                </FormControlWrapper>
                            </Grid>
                        </React.Fragment>
                    )}
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Grid item xs={12} sm={12} md={6} lg={3} >
                            <FormControlWrapper label="Study Start" variant="inline" labelMinWidth={labelMinWidth} isRequired={props.filterData.dateStart.isRequired}>
                                <KeyboardDatePicker
                                    variant="inline"
                                    format="MM/dd/yyyy"
                                    margin="none"
                                    inputVariant="outlined"
                                    id="date-picker-inline"
                                    size="small"
                                    // color="error"
                                    value={props.filterData.dateStart.value}
                                    onChange={(value) => props.onFilterChange('dateStart', value)}
                                />
                            </FormControlWrapper>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={3} >
                            <FormControlWrapper label="Study End" variant="inline" labelMinWidth={labelMinWidth} isRequired={props.filterData.dateEnd.isRequired}>
                                <KeyboardDatePicker
                                    minDate={props.filterData.dateStart.value}
                                    variant="inline"
                                    format="MM/dd/yyyy"
                                    margin="none"
                                    inputVariant="outlined"
                                    size="small"
                                    id="date-picker-inline"
                                    value={props.filterData.dateEnd.value}
                                    onChange={(value) => props.onFilterChange('dateEnd', value)}
                                />
                            </FormControlWrapper>
                        </Grid>
                    </MuiPickersUtilsProvider>


                    <Grid item xs={12} sm={12} md={6} lg={3} className="appButtonGroup">
                        <Button variant="contained" onClick={onFilterClear}>Clear</Button>
                        <Button variant="contained" color="primary" onClick={props.onFilterApply}>Search</Button>
                    </Grid>

                </Grid>
            </AccordionDetails>
        </Accordion>
    )
}
export default StudyBrowserFilters;
